import { useState, useEffect } from 'react';

export const useDeviceSize = () => {
  const [isLargeDevice, setIsLargeDevice] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeDevice(window.innerWidth >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isLargeDevice;
};
